import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Modal,
  Upload,
  Divider,
  Form,
  Select,
  DatePicker,
  Row,
  Col,
  Result,
  Tabs,
} from "antd";
import { platformApi, baseUrl } from "../../../api";
import BookingRegisterModal from "../BookingRegister/BookingRegisterModal";
import BookingRegisterTable from "../BookingRegister/BookingRegisterTable";
import VehicleSaleModal from "../VehicleSaleInvoice/VehicleSaleModal";
import { ContextAPI } from "../../../ContextAPI";
import { useLocation } from "react-router-dom";
import moment from "moment";
import "../BookingRegister/index.less";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;
const { TabPane } = Tabs;
const { Option } = Select;
const { Item: FormItem } = Form;

export default function SalesRegister() {
  const [addFlag, setAddFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [bookingType, setBookingType] = useState("ConfirmBooking");
  const [spinning, setSpinning] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bookingsData, setBookingsData] = useState([]);
  const [bFlag, setBFlag] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(null);
  const [search, setSearch] = useState(null);
  const [tabCounts, setTabCounts] = useState({
    toInvoice: 0,
    invoiced: 0,
    INSURANCE: 0,
    RFR: 0,
    NPO: 0,
    NPR: 0,
    NPF: 0,
    COMPLETED: 0,
  });
  const { loginCredintials } = useContext(ContextAPI);
  const [saleId, setSaleId] = useState("");
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [printAccess, setPrintAccess] = useState(false);
  const [gst, setGst] = useState();
  const [confirm, setConfirm] = useState(false);
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [selectedEngineNo, setSelectedEngineNo] = useState("");
  const [activeTab, setActiveTab] = useState("toInvoice");
  const [isEdit, setIsEdit] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [insuranceBulkModal, setInsuranceBulkModal] = useState(false);
  const [selectedSaleId, setSelectedSaleId] = useState(null);
  const [bulkUploads, setBulkUploads] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [insurancePair, setInsurancePair] = useState({});
  const [uploading, setUploading] = useState(false);

  const location = useLocation();

  useEffect(() => {
    // Load insurance options
    platformApi.get("/api/insurance").then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setInsurances(response.data);
          const pair = {};
          for (let item of response.data) {
            pair[item.id] = item.name;
          }
          setInsurancePair(pair);
        }
      }
    });
  }, []);
  // const [clickStatus, setClickStatus] = useState(false);
  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    let menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu), setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };
  //
  useEffect(() => {
    setGst(loginCredintials.branch[0].gst);
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "booking_register") {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
          if (each.access.print) {
            setPrintAccess(true);
          }
        }
      });
  }, []);

  useEffect(() => {
    getAllBooking(null, null, activeTab);
  }, [activeTab]);

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const SALES_TAB_STATUSES = [
    "toInvoice",
    "invoiced",
    "INSURANCE",
    "RFR",
    "NPO",
    "NPR",
    "NPF",
    "COMPLETED",
  ];

  const fetchTabCounts = (searchString = null) => {
    Promise.all(
      SALES_TAB_STATUSES.map((status) =>
        platformApi
          .post("/api/saleRegister/getPage", {
            page: 1,
            size: 1,
            searchString,
            status,
          })
          .then((res) => {
            const countVal = res?.data?.data?.count ?? 0;
            return { status, count: countVal };
          })
          .catch(() => ({ status, count: 0 }))
      )
    ).then((results) => {
      const next = {};
      results.forEach(({ status, count: c }) => {
        next[status] = c;
      });
      setTabCounts((prev) => ({ ...prev, ...next }));
    });
  };

  const getAllBooking = (value = null, val, status = activeTab) => {
    setSpinning(true);
    platformApi
      .post("/api/saleRegister/getPage", {
        page: val ? val : page,
        size: limit,
        searchString: value,
        status,
      })
      .then((res) => {
        setSpinning(false);
        let { data } = res;
        if (data.code === 200) {

          setBookingsData(
            data.data.saleRegisters.map((item) => ({
              ...item.saleData,
              saleId: item.saleId,
              salesId: item.id,
              bookingUuid: item.saleData?.id,
              id: item.id, // Ensure primary ID is SaleRegister ID
              bookingId: item.bookingId,
              customerFeedback: item.customerFeedback,
              pdf: item.saleInvoice?.invoiceNo 
                ? `/api/saleInvoice/generate?invoiceNo=${encodeURIComponent(item.saleInvoice.invoiceNo)}` 
                : item.saleInvoice?.pdf,
              rtoDocuments: item.rtoDocuments
            }))
          );

          setMainData(data.data.saleRegisters)
          setCount(data.data.count);
          setTabCounts((prev) => ({
            ...prev,
            [status]: data.data.count ?? 0,
          }));
        } else {
          message.error("Failed to fetch booking");
        }
      })
      .catch((error) => {
        setSpinning(false);
        console.error("Error on booking : ", error);
        message.error("Failed to fetch booking");
      });
  };

  useEffect(() => {
    getAllBooking(search);
  }, [page, limit, search]);

  useEffect(() => {
    fetchTabCounts(search);
  }, [search]);

  const openInsuranceBulkModal = (saleId) => {
    setSelectedSaleId(saleId);
    setInsuranceBulkModal(true);
    setBulkUploads([]);
  };


  const handleBulkUpload = (file) => {
    const tempId = `${Date.now()}-${file.uid}`;
    const pendingItem = {
      tempId,
      file,
      insurer: undefined,
      policyNumber: "",
      insuranceType: "",
      validFrom: null,
      validTo: null,
      chassisNumber: "",
      parsing: true,
    };

    setBulkUploads((prev) => [...prev, pendingItem]);
    parseInsuranceDoc(tempId, file);
    return false; // stop Upload from auto posting
  };

  const parseInsuranceDoc = async (tempId, file) => {
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await platformApi.post("/api/insurance/parse", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const parsed = res?.data?.response?.data || res?.data?.data || {};
      let insuranceType = parsed.insuranceType || "1+5";

      setBulkUploads((prev) =>
        prev.map((item) =>
          item.tempId === tempId
            ? {
              ...item,
              insurer: parsed.insurerId || item.insurer,
              policyNumber: parsed.policyNumber || item.policyNumber,
              insuranceType: insuranceType,
              validFrom: parsed.validFrom
                ? moment(parsed.validFrom, "DD/MM/YYYY")
                : item.validFrom,
              validTo: parsed.validTo
                ? moment(parsed.validTo, "DD/MM/YYYY")
                : item.validTo,
              chassisNumber: parsed.chassisNumber || item.chassisNumber,
              parsing: false,
            }
            : item
        )
      );
    } catch (err) {
      console.error("Failed to parse insurance doc", err);
      message.error("Could not prefill from document");
      setBulkUploads((prev) =>
        prev.map((item) =>
          item.tempId === tempId ? { ...item, parsing: false } : item
        )
      );
    }
  };

  const updateBulkField = (tempId, key, value) => {
    setBulkUploads((prev) =>
      prev.map((item) =>
        item.tempId === tempId
          ? {
            ...item,
            [key]: value,
          }
          : item
      )
    );
  };

  const removeBulkItem = (tempId) => {
    setBulkUploads((prev) => prev.filter((item) => item.tempId !== tempId));
  };

  const saveBulkItem = (item) => {  // Remove async
    const { insurer, policyNumber, insuranceType, validFrom, validTo, file } = item;

    if (item.parsing) {
      message.info("Parsing document... please wait");
      return;
    }

    if (!insurer || !policyNumber || !insuranceType || !validFrom || !validTo || !file) {
      message.warning("Fill all fields for this upload before saving");
      return;
    }

    // Mark as saved locally (add a flag)
    updateBulkField(item.tempId, "savedLocally", true);

    message.success("Document saved locally. Click 'Save All' to submit.");
  };

  const saveAllBulkItems = async () => {
    // Get only items that are saved locally
    const itemsToSave = bulkUploads.filter(item => item.savedLocally);
    if (itemsToSave.length === 0) {
      message.warning("No documents to save. Click 'Save' on individual documents first.");
      return;
    }

    // UNIQUE POLICY NUMBER VALIDATION
    const policyNumbers = itemsToSave.map(item => item.policyNumber ? item.policyNumber.trim() : "").filter(p => p !== "");
    const uniquePolicyNumbers = new Set(policyNumbers);
    if (policyNumbers.length !== uniquePolicyNumbers.size) {
      message.error("Policy numbers must be unique across all uploads.");
      return;
    }

    try {
      setUploading(true);

      // Create the insuranceData array exactly like in your example
      const insuranceData = [];

      for (const item of itemsToSave) {
        const { insurer, policyNumber, insuranceType, validFrom, validTo, file } = item;

        // Upload the document - match the ImageUploader format
        const formData = new FormData();
        formData.append("profile", file);
        formData.append("module", "vehicle"); // Changed from "Sale" to "vehicle"
        formData.append("type", "Insurance"); // Keep as "Insurance"
        formData.append("master", "Transaction Master"); // Changed to match ImageUploader
        formData.append("id", "");

        const uploadRes = await platformApi.post("/api/upload/vehicleInsurance", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (uploadRes.data.code === 200) {
          const uploadedFile = uploadRes.data.response?.data || uploadRes.data.data;
          const documentUrl = uploadedFile?.url || uploadedFile?.Location;

          if (documentUrl) {
            // Ensure proper date formatting for Form14 compatibility
            const formattedValidFrom = moment(validFrom).format("DD-MM-YYYY");
            const formattedValidTo = moment(validTo).format("DD-MM-YYYY");

            const insuranceItem = {
              id: "",
              insurer: insurer,
              policyNumber: policyNumber,
              insuranceType: insuranceType,
              chassisNumber: item.chassisNumber,
              validFrom: moment(validFrom).toISOString(), // ISO string format for backend
              validTo: moment(validTo).toISOString(), // ISO string format for backend
              validFromDisplay: formattedValidFrom, // Display format for Form14
              validToDisplay: formattedValidTo, // Display format for Form14
              pdf: {
                file: {
                  originFileObj: {
                    uid: file.uid // Use file UID
                  }
                }
              },
              url: documentUrl
            };

            console.log('Insurance Bulk Upload - Item Data:', {
              policyNumber,
              insurer,
              validFrom: formattedValidFrom,
              validTo: formattedValidTo,
              chassisNumber: item.chassisNumber
            });

            insuranceData.push(insuranceItem);
          } else {
            console.error("No document URL in upload response");
            message.error(`Failed to upload ${file.name}`);
          }
        } else {
          console.error("Upload failed:", uploadRes.data);
          message.error(`Failed to upload ${file.name}`);
        }
      }
      if (insuranceData.length > 0) {
        const payload = { insuranceData };

        try {
          const bulkRes = await platformApi.post("/api/insurance/bulk", payload);

          if (bulkRes.data.code === 200) {
            // Remove all successfully saved items
            itemsToSave.forEach(item => removeBulkItem(item.tempId));
            message.success(`${insuranceData.length} insurance documents saved successfully!`);

            // Close modal if all items are processed
            if (bulkUploads.length === 0) {
              setInsuranceBulkModal(false);
            }
          } else {
            setInsuranceBulkModal(false);
            message.error("Failed to save insurance documents to database");
          }
        } catch (bulkErr) {
          console.error("Bulk API error:", bulkErr);
          message.error("Failed to connect to bulk insurance API");
        }
      } else {
        message.error("No documents were successfully uploaded");
      }
    } catch (err) {
      console.error("Error in saveAllBulkItems:", err);
      message.error("Failed to save insurance documents");
    } finally {
      setUploading(false);
      setInsuranceBulkModal(false);
      clearInsuranceBulkFields();
      getAllBooking(null, 1, "invoiced");
      fetchTabCounts(search);
    }
  };

  const getSelectedBooking = (id, editable = false) => {
    // const encodedId = encodeURIComponent(id); 

    return platformApi
      .get(`/api/saleRegister/getOne/${id}`)
      .then((res) => {
        let { data } = res;
        if (data.code === 200) {
          if (editable) {
            data.data.saleData.authentication = {
              afterVerification: null,
              beforeVerification: null,
              digital: null,
              id: data.data.saleData.authentication?.id || null,
              manual: null,
              verifiedAt: null,
            };
          }
          setSaleId(data.data.id);
          setSelectedEngineNo(data.data.engineNo);
          const ds = { 
            ...data.data.saleData, 
            saleId: data.data.saleId,
            engineNo: data.data.engineNo,
            chassisNumber: data.data.chassisNumber,
            bookingId: data.data.bookingId
          };
          setSelectedBooking(ds);
          return ds;
        }
      })
      .catch((error) => {
        console.error("Error on booking : ", error);
      });
  };


  const getSelectInvoice = (id) => {
    platformApi.get(`/api/saleInvoice/${id}`).then((res) => {
      setSelectedBooking(res.data.response.data || res.data.response);
    });
  }

  const deleteData = (id) => {
    setSpinning(true);
    let temp = page != 1 && bookingsData.length === 1;
    platformApi
      .delete("/api/booking/" + id)
      .then((result) => {
        setSpinning(false);
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            if (temp) {
              setPage(1);
              getAllBooking(null, 1);
            } else {
              getAllBooking();
            }
            fetchTabCounts(search);
            message.success("Deleted Sucessfully", 2);
          } else {
            message.error("Unable to delete Booking", 2);
          }
        } else {
          message.error("Unable to delete booking", 2);
        }
      })
      .catch((error) => {
        setSpinning(false);
        console.error("Error on booking : ", error);
        message.error("Unable to delete booking", 2);
      });
  };
  const addData = (bookingRegister, showMessage = false) => {
    setSpinning(true);
    if (confirm) {
      bookingRegister.bookingStatus = "PENDING";
      bookingRegister.isAdvanceBooking = false;
    }
    if (bookingRegister.id) {
      platformApi
        .put(`/api/booking/${bookingRegister.id}`, bookingRegister)
        .then((res) => {
          setSpinning(false);
          let { data } = res;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              setBookingId(response.data.bookingId);
              setSelectedBooking(response.data);
              // if(JSON.stringify(bookingRegister)===JSON.stringify(response.data))
              showMessage && message.success("Booking saved successfully", 1);
            } else {
              message.error("Unable to save booking", 1);
            }
          } else {
            message.error("Unable to save booking", 1);
          }
        })
        .catch((err) => {
          setSpinning(false);
          message.error("Unable to save booking", 1);
          console.error("Error on booking : ", err);
        });
    } else {
      platformApi
        .post("/api/booking/create", bookingRegister)
        .then((res) => {
          setSpinning(false);
          let { data } = res;
          if (data.code === 200) {
            let { response } = res.data;
            if (response.code === 200) {
              setSelectedBooking(response.data);
              if (response.data.bookingStatus === "ACCEPTED")
                sendConfirmSMS(response.data);
              message.success("Booking added successfully");
            } else {
              message.error("Error in booking creation");
            }
          } else {
            message.error("Error in booking creation");
          }
        })
        .catch((err) => {
          console.error("Error on booking : ", err);
        });
    }
  };

  const sendConfirmSMS = (data) => {
    const {
      bookingId,
      branch,
      executive: {
        profile: { employeeName },
      },
      authentication,
      customer: { name, contacts },
      vehicle: { modelName },
    } = data;
    const phone = contacts[0].phone;
    const smsdata = {
      pdflink:
        authentication.afterVerification || authentication.beforeVerification,
      cname: name,
      vname: modelName,
      bkid: bookingId,
      slex: employeeName,
      clink: "-",
      dlr: branch.name,
    };
    platformApi
      .post("/api/sendSms/bookingconfirm", {
        phone,
        smsdata,
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          message.success("Message sent successfully");
        } else if (data.code === 401) {
          message.error(data.message);
        } else {
          message.error("Unable to send SMS");
        }
      });
  };

  const openModal = (id, editable) => {
    setEditFlag(editable);
    getSelectedBooking(id, editable).then((ds) => {
      if (ds) {
        setAddFlag(true);
      }
    });
  };

  const openInvoiceModal = (id, editable) => {
    if (!editable) {
      getSelectedBooking(id);
    } else {
      getSelectInvoice(id);
    }
    setIsEdit(editable);
    setInvoiceModal(true);
  };

  const clearInsuranceBulkFields = () => {
    setBulkUploads([]);
    setSelectedSaleId(null);
    setUploading(false);
  };

  // ========================================
  // FORM14 ISSUE FIXES
  // ========================================
  // 
  // Issue 1: Negative Tax Value in Form14
  // - Fixed tax calculation to always return positive values
  // - Added fallback tax amount (Rs 500) when vehicle price is 0
  // - Used Math.abs() to ensure positive values
  // - Added proper error handling
  //
  // Issue 2: Incorrect Insurance Dates in Form14
  // - Enhanced insurance bulk upload to include display-formatted dates
  // - Added validFromDisplay and validToDisplay fields in DD-MM-YYYY format
  // - Modified Form14 download to pass correct date parameters
  // - Added insurance data retrieval from sale records
  //
  // Changes Made:
  // 1. calculateForm14Tax() - Ensures positive tax calculation
  // 2. handleForm14Download() - Passes corrected parameters to Form14 API
  // 3. saveAllBulkItems() - Adds display-formatted dates to insurance data
  // 4. BookingRegisterTable - Updated to use new Form14 handler
  //
  // ========================================

  // Function to fix tax calculation for Form14
  const calculateForm14Tax = (saleData) => {
    if (!saleData) return 0;

    // Ensure tax is always positive
    let tax = 0;

    try {
      // Calculate tax from vehicle price or sale amount
      const vehiclePrice = saleData.vehicle?.exShowroomPrice ||
        saleData.totalAmount ||
        saleData.vehiclePrice ||
        saleData.saleAmount ||
        0;

      const gstPercentage = gst || 18; // Default to 18% if not set

      // Calculate GST tax (always positive)
      tax = Math.abs((vehiclePrice * gstPercentage) / 100);

      // If vehicle price is 0 or invalid, use a minimum tax amount
      if (vehiclePrice <= 0) {
        tax = 500; // Minimum tax amount to avoid negative or zero values
      }

      // Ensure minimum tax of 0 (no negative values)
      tax = Math.max(0, tax);

      // Round to 2 decimal places
      tax = Math.round(tax * 100) / 100;

    } catch (error) {
      console.error('Error calculating Form14 tax:', error);
      tax = 500; // Fallback tax amount
    }

    return tax;
  };

  // Enhanced Form14 download handler with tax fix
  const handleForm14Download = (salesId, event) => {
    console.log('Form14 Download - Processing with tax and date fixes');
    event.preventDefault();
    event.stopPropagation();

    // Get the sale data to calculate correct tax
    const saleRecord = mainData.find(item => item.id === salesId);
    if (!saleRecord) {
      console.error('Sale record not found for salesId:', salesId);
      message.error("Sale record not found");
      return;
    }

    // Calculate correct tax
    const correctTax = calculateForm14Tax(saleRecord.saleData);

    // Get insurance data for correct dates
    const insuranceData = {
      validFrom: null,
      validTo: null,
      policyNumber: null,
      insurer: null
    };

    // Try to get insurance data from bulk uploads or existing records
    if (saleRecord.insurance && saleRecord.insurance.length > 0) {
      const latestInsurance = saleRecord.insurance[saleRecord.insurance.length - 1];
      insuranceData.validFrom = latestInsurance.validFrom;
      insuranceData.validTo = latestInsurance.validTo;
      insuranceData.policyNumber = latestInsurance.policyNumber;
      insuranceData.insurer = latestInsurance.insurer;
    }

    // Build Form14 URL with corrected parameters
    const params = new URLSearchParams();
    params.append('tax', correctTax.toString());

    if (insuranceData.validFrom) {
      params.append('validFrom', moment(insuranceData.validFrom).format("DD-MM-YYYY"));
    }
    if (insuranceData.validTo) {
      params.append('validTo', moment(insuranceData.validTo).format("DD-MM-YYYY"));
    }
    if (insuranceData.policyNumber) {
      params.append('policyNumber', insuranceData.policyNumber);
    }
    if (insuranceData.insurer) {
      params.append('insurer', insuranceData.insurer);
    }

    // Open Form14 with corrected parameters
    const form14Url = `${baseUrl}api/saleregister/form14/${salesId}?${params.toString()}`;
    console.log('Form14 URL with corrections:', form14Url);
    window.open(form14Url, '_blank');

    // Log the correction for debugging
    console.log('Form14 Download - Corrections Applied:', {
      salesId,
      correctedTax: correctTax,
      insuranceDates: {
        validFrom: insuranceData.validFrom ? moment(insuranceData.validFrom).format("DD-MM-YYYY") : null,
        validTo: insuranceData.validTo ? moment(insuranceData.validTo).format("DD-MM-YYYY") : null
      }
    });
  };

  const handleForm19Download = (salesId, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const form19Url = `${baseUrl}api/saleregister/form19/${salesId}`;
    window.open(form19Url, '_blank');
  };

  const renderTabLabel = (label, statusKey) => (
    <span className="register-tab-label">
      <span>{label}</span>
      <span className="register-tab-count">{tabCounts[statusKey] ?? 0}</span>
    </span>
  );

  const menu = <Menu>{getMenu()}</Menu>;
  return (
    <div>
      <div className="accessories-head register-page-head">
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <h3 className="register-page-title">Sales Register</h3>
          {/* <Dropdown overlay={menu} trigger={["click"]}>
            <Button>
              {limit}&nbsp;
              <Icon type="down" />
            </Button>
          </Dropdown> */}
        </div>
        <div className="register-page-toolbar">
          {activeTab === "invoiced" && (
            <Button
              type="primary"
              className="register-page-btn-primary"
              onClick={() => {
                setInsuranceBulkModal(true);
              }}
            >
              <Icon type="upload" /> Upload Insurance Bulk
            </Button>
          )}
          <Search
            style={{ width: 220 }}
            placeholder="Search bookings..."
            onSearch={(event) => {
              setPage(1);
              setSearch(event);
            }}
            onChange={(event) => {
              if (event.target.value === "") {
                setSearch(null);
                setPage(1);
              }
            }}
          />
        </div>
      </div>
      <Tabs
        className="register-page-tabs"
        activeKey={activeTab}
        onChange={handleTabChange}
      >
        <TabPane tab={renderTabLabel("To Invoice", "toInvoice")} key="toInvoice" />
        <TabPane tab={renderTabLabel("Invoiced", "invoiced")} key="invoiced" />
        <TabPane tab={renderTabLabel("Insured", "INSURANCE")} key="INSURANCE" />
        <TabPane
          tab={renderTabLabel("Ready For Registration", "RFR")}
          key="RFR"
        />
        <TabPane tab={renderTabLabel("Number Plate Ordered", "NPO")} key="NPO" />
        <TabPane
          tab={renderTabLabel("Number Plate Received", "NPR")}
          key="NPR"
        />
        <TabPane tab={renderTabLabel("Number Plate Fixed", "NPF")} key="NPF" />
        <TabPane tab={renderTabLabel("Completed", "COMPLETED")} key="COMPLETED" />
      </Tabs>
      <BookingRegisterTable
        pagination={{
          onChange: (page) => {
            setPage(page);
          },
          pageSize: limit,
          defaultCurrent: 1,
          total: count,
          current: page,
          showQuickJumper: true,
        }}
        type={"sold"}
        invoiceStatus={
          activeTab == "toInvoice" ||
          activeTab == "invoiced" ||
          activeTab == "INSURANCE" ||
          activeTab == "RFR"
            ? true
            : false
        }
        openModal={openModal}
        openInvoiceModal={openInvoiceModal}
        onBulkUpload={(saleId) => openInsuranceBulkModal(saleId)}
        onForm14Download={handleForm14Download}
        onForm19Download={handleForm19Download}
        tab={activeTab}
        isSales={true}
        onDelete={(id) => deleteData(id)}
        mainData={mainData}
        dataSource={bookingsData}
        spinner={{
          spinning,
        }}
        printAccess={printAccess}
        refreshData={() => getAllBooking()}
      />
      <Modal
        title="Upload Insurance Bulk Documents"
        visible={insuranceBulkModal}
        onCancel={() => {
          setInsuranceBulkModal(false);
          clearInsuranceBulkFields();
        }}
        width={1200}
        footer={[
          <Button key="cancel" onClick={() => {
            setInsuranceBulkModal(false);
            clearInsuranceBulkFields();
          }}>
            Cancel
          </Button>,
          <Button
            key="saveAll"
            type="primary"
            onClick={saveAllBulkItems}
            loading={uploading}
          >
            Save All
          </Button>,
        ]}
      >
        <div style={{ marginBottom: "20px" }}>
          <Upload
            beforeUpload={handleBulkUpload}
            fileList={[]}
            multiple
            accept=".pdf"
            showUploadList={false}
            disabled={uploading}
          >
            <Button type="dashed" icon="upload">
              Add Insurance Documents
            </Button>
          </Upload>
          <p style={{ marginTop: "8px", color: "#999" }}>
            Upload multiple insurance PDFs to prefill details automatically
          </p>
        </div>

        {bulkUploads.length > 0 && (
          <>
            <Divider />
            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
              {bulkUploads.map((item) => (
                <div
                  key={item.tempId}
                  style={{
                    border: "1px solid #f0f0f0",
                    padding: "12px",
                    marginBottom: "12px",
                    borderRadius: "6px",
                  }}
                >
                  <Row type="flex" justify="space-between" gutter={16}>
                    <Col span={6}>
                      <FormItem label="Insurer">
                        <Select
                          placeholder="Select Insurer"
                          value={item.insurer}
                          showSearch
                          filterOption={(input, option) => {
                            // Safe handling of option props
                            const text = String(option?.props?.children || '');
                            return text.toLowerCase().includes(input.toLowerCase());
                          }}
                          onChange={(val) =>
                            updateBulkField(item.tempId, "insurer", val)
                          }
                          disabled={item.parsing || uploading}
                          style={{ width: "100%" }}
                        >
                          {insurances.map((ins) => (
                            <Option value={ins.id} key={ins.id}>
                              {ins.name || ''} {/* Empty string fallback */}
                            </Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span={5}>
                      <FormItem label="Policy No">
                        <Input
                          placeholder="Policy Number"
                          value={item.policyNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                            updateBulkField(item.tempId, "policyNumber", value);
                          }}
                          disabled={item.parsing || uploading}
                        />
                      </FormItem>
                    </Col>
                    <Col span={4}>
                      <FormItem label="Insurance Type">
                        <Select
                          placeholder="Type"
                          value={item.insuranceType}
                          onChange={(val) =>
                            updateBulkField(item.tempId, "insuranceType", val)
                          }
                          disabled={item.parsing || uploading}
                          style={{ width: "100%" }}
                        >
                          <Option value="1+5">1+5</Option>
                          <Option value="1+5 Zero Dep">1+5 Zero Dep</Option>

                        </Select>
                      </FormItem>
                    </Col>
                    <Col span={4}>
                      <FormItem label="Valid From">
                        <DatePicker
                          format="DD-MM-YYYY"
                          value={item.validFrom ? moment(item.validFrom) : null}
                          disabledDate={(m) =>
                            item.validTo
                              ? m._d >= item.validTo._d
                              : false
                          }
                          onChange={(val) =>
                            updateBulkField(item.tempId, "validFrom", val)
                          }
                          disabled={item.parsing || uploading}
                          style={{ width: "100%" }}
                        />
                      </FormItem>
                    </Col>
                    <Col span={4}>
                      <FormItem label="Valid To">
                        <DatePicker
                          format="DD-MM-YYYY"
                          value={item.validTo ? moment(item.validTo) : null}
                          disabledDate={(m) =>
                            item.validFrom
                              ? m._d <= item.validFrom._d
                              : false
                          }
                          onChange={(val) =>
                            updateBulkField(item.tempId, "validTo", val)
                          }
                          disabled={item.parsing || uploading}
                          style={{ width: "100%" }}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={24}>
                      <FormItem label="Chassis No : ">
                        <Select
                          showSearch
                          placeholder="Search by Customer, Model or Chassis"
                          value={item.chassisNumber}
                          style={{ width: "100%" }}
                          filterOption={(input, option) => {
                            const text = String(option?.props?.children || "");
                            return text.toLowerCase().includes(input.toLowerCase());
                          }}
                          onChange={(val) =>
                            updateBulkField(item.tempId, "chassisNumber", val)
                          }
                          disabled={item.parsing || uploading}
                        >
                          {bookingsData
                            .filter(booking => {
                              const chassis = booking.chassisNo || booking.chassisNumber;
                              // Exclude if already selected in ANOTHER item in the bulk uploads
                              const isAlreadySelected = bulkUploads.some(u =>
                                u.tempId !== item.tempId && (u.chassisNumber === chassis)
                              );
                              return !isAlreadySelected;
                            })
                            .map((booking) => (
                              <Option key={booking.salesId} value={booking.chassisNo || booking.chassisNumber}>
                                {`${booking.customer?.name || "N/A"} - ${booking.vehicle?.modelName || "N/A"} - ${booking.chassisNo || booking.chassisNumber || "N/A"}`}
                              </Option>
                            ))}
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "8px",
                        }}
                      >
                        <div>
                          <span style={{ marginRight: "16px" }}>
                            File: <strong>{item.file?.name}</strong>
                          </span>
                          {item.parsing && (
                            <span style={{ color: "#1890ff" }}>
                              <Icon type="loading" /> Prefilling details...
                            </span>
                          )}
                          {item.savedLocally && (  // Add this indicator
                            <span style={{ color: "#52c41a", marginLeft: "8px" }}>
                              <Icon type="check-circle" /> Saved
                            </span>
                          )}
                        </div>
                        <div>
                          <Button
                            type="primary"
                            onClick={() => saveBulkItem(item)}
                            disabled={item.parsing || uploading || item.savedLocally}  // Disable if already saved
                            style={{ marginRight: "8px" }}
                          >
                            {item.savedLocally ? "Saved" : "Save"}
                          </Button>
                          <Button
                            onClick={() => removeBulkItem(item.tempId)}
                            disabled={uploading}
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          </>
        )}
      </Modal>

      {invoiceModal && (
        <VehicleSaleModal
          id={bookingId}
          open={invoiceModal}
          saleId={saleId}
          setSaleId={setSaleId}
          engineNo={selectedEngineNo}
          dataSource={selectedBooking}
          isEdit={isEdit}
          close={() => {
            setInvoiceModal(false);
            setSelectedBooking(null);
            getAllBooking();
            fetchTabCounts(search);
          }}
        />
      )}

      <BookingRegisterModal
        mode={
          bookingType == "AdvancedBooking" && confirm == true
            ? "ConfirmBooking"
            : bookingType
        }
        id={bookingId}
        currentData={selectedBooking}
        isSales={true}
        emitData={(data, showMessage) => addData(data, showMessage)}
        editable={editFlag}
        open={addFlag}
        setBFlag={setBFlag}
        bFlag={bFlag}
        clearBookingData={(data) => setSelectedBooking(data)}
        close={() => {
          setSelectedBooking(null);
          setAddFlag(false);
          setBFlag(false);
          getAllBooking();
          fetchTabCounts(search);
          setConfirm(false);
        }}
      />
    </div>
  );
}
